"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSanitizedCategoriesList = void 0;
const getSanitizedCategoriesList = (categories) => {
    if (!Array.isArray(categories))
        return [];
    return categories.map((c) => {
        const cat = Object.assign({}, c);
        // @ts-expect-error
        if (typeof cat.maxYearlyNumber === typeof null || cat.maxYearlyNumber === '')
            delete cat.maxYearlyNumber;
        // @ts-expect-error
        if (typeof cat.maxDailyMinutes === typeof null || cat.maxDailyMinutes === '')
            delete cat.maxDailyMinutes;
        if (typeof cat.customId === typeof null || cat.customId === '')
            delete cat.customId;
        if (typeof cat.archived !== 'boolean')
            delete cat.archived;
        return cat;
    });
};
exports.getSanitizedCategoriesList = getSanitizedCategoriesList;
